import { LucideIcon } from 'lucide-react';

interface PrimaryButtonProps {
  onClick: () => void;
  icon: LucideIcon;
  label?: string;
  /** `data-tour` anchor, for a What's New walk that has to point here. */
  dataTour?: string;
  disabled?: boolean;
  title?: string;
  /** Icon-only variant for compact/mobile views */
  iconOnly?: boolean;
}

export function PrimaryButton({
  onClick,
  icon: Icon,
  label,
  dataTour,
  disabled = false,
  title,
  iconOnly = false,
}: PrimaryButtonProps) {
  if (iconOnly) {
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        data-tour={dataTour}
        className="inline-flex items-center justify-center w-9 h-9 bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        title={title || label}
      >
        <Icon className="w-4 h-4" />
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-tour={dataTour}
      className="inline-flex items-center gap-2 px-3 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed min-w-0"
      title={title || label}
    >
      <Icon className="w-4 h-4 flex-shrink-0" />
      <span className="truncate">{label}</span>
    </button>
  );
}
